import { css } from 'linaria';

export const priceViewInLine = css`
  display: flex;
  column-gap: 8px;
`;

export const priceViewDiscount = css`
  margin-bottom: 6px;
`;

export const priceView = css`
  display: flex;
  justify-content: space-between;
`;

export const priceWrapper = css`
  font-weight: 600;
`;

export const priceValue = css`
  && {
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
  }
`;

export const priceValueWithDiscount = css`
  && {
    @media (--only-mobile) {
      font-size: 14px;
      line-height: 20px;
    }
  }
`;
